import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDateValue } from '../../utils/date';

class AccoFlowDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contract: {},
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    render() {
        const { contract } = this.props;

        return (
            <div>
                {contract ?
                    <table className="date-table acco-table">
                        <thead>
                            <tr>
                                <th>Subphase</th>
                                <th>Scheduled Start - End</th>
                                <th>Actual Start - End</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>In Legal</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.inLegalSchedStart)} - {getDateValue(contract.inLegalSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.inLegalActualStart)} - {getDateValue(contract.inLegalActualEnd)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>In Advertisement</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.inAdvertisingSchedStart)} - {getDateValue(contract.inAdvertisingSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.inAdvertisingActualStart)} - {getDateValue(contract.inAdvertisingActualEnd)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Bid Advertisement</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.schedBidSchedStart)} - {getDateValue(contract.schedBidSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.schedBidActualStart)} - {getDateValue(contract.schedBidActualEnd)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Bid Dates</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.bidDatesSchedStart)} - {getDateValue(contract.bidDatesSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.bidDatesActualStart)} - {getDateValue(contract.bidDatesActualEnd)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Pre-Award</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.preAwardSchedStart)} - {getDateValue(contract.preAwardSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.preAwardActualStart)} - {getDateValue(contract.preAwardActualEnd)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Award</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.awardSchedStart)} - {getDateValue(contract.awardSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.awardActualStart)} - {getDateValue(contract.awardActualEnd)}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Registration</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.registrationSchedStart)} - {getDateValue(contract.registrationSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.registrationActualStart)} - {getDateValue(contract.registrationActualEnd)} </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Execution</td>
                                <td className="dt-green auto-width">
                                    <span>{getDateValue(contract.executionSchedStart)} - {getDateValue(contract.executionSchedEnd)}</span>
                                </td>
                                <td className='dt-red auto-width'>
                                    <span>{getDateValue(contract.executionActualStart)} - {getDateValue(contract.executionActualEnd)}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    : <p>No Acco Flow Details are found for this contract</p>}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        projectId: ownProps.projectId,
    };
}

export default connect(mapStateToProps)(AccoFlowDetails);